module.exports = __webpack_public_path__ + "img/21.b53d1f84.jpg";